module.exports = __webpack_public_path__ + "img/champ.47f81586.png";